import { createAction } from "@ngrx/store";

export const init = createAction("[Room/Producer] Init");
export const destroy = createAction("[Room/Producer] Destroy");
